import { MODULE } from '@/constant/common';
// 模块名称
export const NAME = MODULE.COMMON;
// GETTER名称
export const GETTER = {
  GET_ORIGIN_METADATA: 'getOriginMetadata',
  GET_CUSTOM_METADATA: 'getCustomMetadata',
  GET_ENTITY_ID_BY_ENTITY_SET: 'getEntityIdByEntitySet'
};
// MUTATION名称
export const MUTATION = {
  UPDATE_ENTITY: 'updateEntity',
  CLEAR_ENTITY: 'clearEntity',
  UPDATE_CUSTOM_ENTITY: 'updateCustomEntity'
};
// ACTION名称
export const ACTION = {
  FETCH_ENTITY: 'fetchEntity'
};
export const COMMON = {
  NAME,
  GETTER: {
    GET_ORIGIN_METADATA: `${NAME}/${GETTER.GET_ORIGIN_METADATA}`,
    GET_CUSTOM_METADATA: `${NAME}/${GETTER.GET_CUSTOM_METADATA}`,
    GET_ENTITY_ID_BY_ENTITY_SET: `${NAME}/${GETTER.GET_ENTITY_ID_BY_ENTITY_SET}`
  },
  // 注册的key，因module的namespace为true，因此需要包含父module的name
  MUTATION: {
    UPDATE_ENTITY: `${NAME}/${MUTATION.UPDATE_ENTITY}`,
    CLEAR_ENTITY: `${NAME}/${MUTATION.CLEAR_ENTITY}`,
    UPDATE_CUSTOM_ENTITY: `${NAME}/${MUTATION.UPDATE_CUSTOM_ENTITY}`
  },
  ACTION: {
    FETCH_ENTITY: `${NAME}/${ACTION.FETCH_ENTITY}`
  }
};
export default COMMON;